export const gameWords = [
  [
    "Elm",
    "Low",
    "Owe",
    "Owl",
    "Mellow",
    "Meow",
    "Mew",
    "Mewl",
    "Mole",
    "Moll",
    "Mow",
    "Well",
    "Woe",
  ],
  [
    "Gifts",
    "Sight",
    "This",
    "Fit",
    "Fig",
    "His",
    "Hits",
    "Its",
    "Sit",
    "Sigh",
    "Shift",
    "Figs",
    "Fish",
    "Fist",
    "Fits",
    "Gift",
    "Gist",
    "Hits",
    "Ifs",
    "Sift",
    "Fight",
    "Fights",
  ],
  [
    "Slime",
    "Smile",
    "Miles",
    "Slimes",
    "Smiles",
    "Elm",
    "Lei",
    "Lie",
    "Mil",
    "Elms",
    "Slim",
    "Mise",
    "Semi",
    "Isle",
    "Leis",
    "Less",
    "Lies",
    "Lime",
    "Mess",
    "Mile",
    "Miss",
    "Isles",
    "Limes",
    "Seism",
    "Semis",
  ],
  ["Crayon", "Crony", "Corny", "Rayon", "Any", "Arc", "Can", "Car", "Cay", "Con", "Corn", "Cory", "Coy", "Cry", "Nay", "Nor", "Oar", "Orca", "Ran", "Ray", "Roc", "Rya", "Yon", "Cran", "Cyan", "Narc", "Racy", "Roan", "Yarn", "Acorn", "Carny", "Crony"],

  ["Ragged", "Raged", "Grade", "Gager", "Age", "Are", "Dag", "Ear", "Egg", "Era", "Erg", "Gad", "Gag", "Gar", "Rad", "Rag", "Red", "Aged", "Dare", "Dear", "Drag", "Dreg", "Egad", "Gage", "Gear", "Grad", "Rage", "Read", "Agger", "Grade", "Dagger"]


];
